import { render } from "./PaymentCancelled.vue?vue&type=template&id=6a1daed0&scoped=true"
const script = {}

import "./PaymentCancelled.vue?vue&type=style&index=0&id=6a1daed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1daed0"]])

export default __exports__